export default __webpack_public_path__ + "static/media/avatar.902faa00.svg";